






















import Vue from 'vue';
import EyeOnIcon from '../../../assets/img/eye_on.svg';
import EyeOffIcon from '../../../assets/img/eye_off.svg';
import InputText from './InputText.vue';
export default Vue.extend({
    components: {
        InputText,
        EyeOnIcon,
        EyeOffIcon,
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isVisible: false,
        };
    },
    computed: {
        type: {
            get(): string {
                return this.isVisible ? 'text' : 'password';
            },
            set(val: string) {
                return val;
            },
        },
    },
    methods: {
        toggle() {
            this.isVisible = !this.isVisible;
            this.type = this.isVisible ? 'text' : 'password';
        },
    },
});
